import { render, staticRenderFns } from "./ClassesInProgress.vue?vue&type=template&id=08a61e0c&"
import script from "./ClassesInProgress.vue?vue&type=script&lang=js&"
export * from "./ClassesInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports